var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-flex"},[_c('SettingsNav',{attrs:{"title":_vm.$t("SETTINGS.MENU.HEADER"),"routes":_vm.settingsChildrenRoutes}}),_c('div',{staticClass:"b-settings-router-view-wrapper"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }